/**
 * Default avatar — deterministic per profile, rendered with boring-avatars
 * ("beam" variant) on the Odisseia night palette. Fills its parent box;
 * the parent controls size and border-radius (overflow-hidden).
 */
import Avatar from 'boring-avatars';
import { cn } from '../lib/utils';

const PALETTE = ['#141F3D', '#DFC993', '#F6E9C8', '#5EEAD4', '#A8B8E8'];

export function DefaultAvatar({
  name,
  className,
}: {
  /** Stable seed — user id, e-mail or name. */
  name: string;
  className?: string;
}) {
  return (
    <span
      className={cn('block h-full w-full [&>svg]:h-full [&>svg]:w-full', className)}
      aria-hidden
    >
      <Avatar size="100%" name={name || 'reformulat'} variant="beam" colors={PALETTE} square />
    </span>
  );
}
